import * as Cart from './cartHelper';
import Moment from 'moment';
export function buildTempOrderData(products) {
  

  let tempOrder = {
    CRV: 0,
    products: [],
    qty: [],
    subTotal: 0,
    sum: 0,
    sumBundle: 0,
  };

  let itemWithoutBundleDiscount = []
  let itemWithBundleDiscount = []
  let itemCRV = []
  let sum = 0
  let sumBundle = 0
  let sumCRV = 0
  
  products && products.map(i => {
    const item = { ...i };
    tempOrder.products.push(item._id);
    tempOrder.qty.push(item['quantity']);

    const discounts = item.QuantityDiscount
          .sort((a, b) => b.quantity - a.quantity);
    if (discounts && discounts.length > 0) {
        item.bundledDiscount = item.QuantityDiscountOddItems ?
        discounts.filter(d =>
            d.quantity <= item.quantity) ?
            discounts.filter(d => d.quantity <= item.quantity)[0]
            : undefined
            : discounts.find(d => d.quantity === item.quantity);

        if (item.bundledDiscount) {
            item.SalePrice = item.bundledDiscount.priceB;
            item.bundle = true;
        } else {
            item.bundle = false;
        }
    }

    if (item.bundle) {
      // signal server to look
      // for bundled discounts
      tempOrder.calculateBundledDiscount = true;
    }

    if (!item['bundle']) {
      item['OnSale'] ? itemWithoutBundleDiscount.push(Number(item['SalePrice'] * item['quantity'])) : itemWithoutBundleDiscount.push(Number(item['PriceB'] * item['quantity']))
    }
    if (item['bundle']) { 
      if (item['quantity'] == 1) {
        itemWithoutBundleDiscount.push(Number(item['PriceB'] * item['quantity']))
      } else {
        itemWithBundleDiscount.push(Number(item['SalePrice'] * item['quantity']))
      }
    }
    if (item['CRV']) {
      itemCRV.push(Number(item['CRV'] * item['quantity']))
    }
    sum = itemWithoutBundleDiscount.reduce(function (a, b) { return a + b }, 0)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    sumBundle = itemWithBundleDiscount.reduce(function (a, b) { return a + b }, 0)
    sumCRV = itemCRV.reduce(function (a, b) { return a + b }, 0)
    tempOrder.CRV = sumCRV
    tempOrder.sum = sum
    tempOrder.sumBundle = sumBundle

    if(item.OnSale || item.bundle) {
      tempOrder.subTotal += parseFloat(item['SalePrice'] * item['quantity']);
    } else {
      tempOrder.subTotal += parseFloat(item['PriceB'] * item['quantity']);
    }
  })
  let promoCode = Cart.getCartAttribute(Cart.ATTRIBUTE_PROMO_CODE)
  if (promoCode) {
    tempOrder.discount = promoCode
    let discountedSubTotal
    discountedSubTotal = Cart.calculateDiscountedSubtotal(tempOrder.sum, tempOrder.sumBundle, tempOrder.calculateBundledDiscount, tempOrder.subTotal, promoCode)
    if (discountedSubTotal && !isNaN(discountedSubTotal))
      tempOrder.subTotal = discountedSubTotal
  }
  tempOrder.subTotal += tempOrder.CRV
  tempOrder.tip = Cart.calculateTipAmount(tempOrder.subTotal);
  tempOrder.tipPercentage = Cart.getCartAttribute(Cart.ATTRIBUTE_TIP_PERCENT)
  tempOrder.address = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS)

  return tempOrder;
}

export function calculateBill(orderData) {
  let subTotal = orderData.subTotal;
  let CRV = orderData.CRV
  let tax = orderData.tax;
  let deliveryFee = orderData.deliveryFee; // not available, set to default value
  let discount = orderData.discount?orderData.discount.code?orderData.discount:{}:{};
  let discountByPromoCode = orderData.discountAmount || 0;
  let tipAmount = orderData.tip;
  let tipPercent = orderData.tipPercentage;
  let total = orderData.total;

  let billData = {
    subTotal: subTotal,
    CRV: CRV,
    tax: tax,
    deliveryFee: deliveryFee,
    discountByPromoCode: discountByPromoCode,
    discount:discount,
    tip: {
      percent: tipPercent,
      amount: tipAmount
    },
    total: total
  };
  console.log("BILL_DATA", billData);
  return billData;
}

export function validateUserDOB(dob) {

  if(dob=="1000-12-01"){
    return {status: false, message: 'Kindly update your DOB'};
  }

  // let formattedDob = Moment(dob, "YYYY-MM-DD").format('L');
  
  // const age = Moment().diff(formattedDob, 'years');
  
  // const isLegal = (age >= 21);
  // if (!isLegal) {
  //   return {
  //     status: false,
  //     message: "You are not 21 years old or Invalid Birthdate"
  //   };
  // }
      return {status: true, message: 'Age is valid'};
    
}
export function validateDeliveryTime(isNowSelected, dateTime) {

  let storeClosedBetween = [130, 900];
  let currentTime = (new Date()).getTime();
  let now = new Date();
  let nowHours = now.getHours();
  let nowMinutes = now.getMinutes();
  let nowFormatted = parseInt(nowHours) * 100 + parseInt(nowMinutes);
  if (isNowSelected) {
    let canOrder = !(nowFormatted > storeClosedBetween[0] && nowFormatted < storeClosedBetween[1])
    // let canOrder = true
    console.log("Can order at this time:", canOrder);

    if (!canOrder) {
      return {status: false, message: 'Unfortunately, we do not accept orders past 1:30am.'};
    }
  } else {
    let selectedTime = dateTime;
    let selectedHours = selectedTime.getHours();
    let selectedMinutes = selectedTime.getMinutes();
    let selectedTimeFormatted = parseInt(selectedHours) * 100 + parseInt(selectedMinutes);
    let canOrder = !(selectedTimeFormatted > storeClosedBetween[0] && selectedTimeFormatted < storeClosedBetween[1])

    let minutesDiff = (selectedTime - currentTime) / (1000 * 60);
    if (minutesDiff < -1) {
      return {status: false, message: 'You cannot select past time'};
    }

    console.log("Can order at this time:", canOrder);
    if (!canOrder) {
      return {status: false, message: 'Unfortunately, we do not accept orders past 1:30am.'};
    }
  }

  console.log("Can order at this time:", true);
  return {status: true, message: 'Delivery time is valid'};
}

export function groupOrders(orders) {

  let groupedOrders = {
      upcomingOrders: [],
      pastOrders: [],
      currentOrders: [],
      canceledOrders: []
  };
  if(!orders) return groupedOrders;

  orders.forEach(function(order) {
    switch (order.status) {
      case "Pending":
      case "In Progress":
        groupedOrders.currentOrders.push(order);
        break;

      case "Accepted":
      case "Assigned":
        groupedOrders.upcomingOrders.push(order);
        break;

      case "Completed":
      case "Approved":
        groupedOrders.pastOrders.push(order);
        break;
      case "Canceled":
        groupedOrders.canceledOrders.push(order);
    }
  });
  return groupedOrders;
}

export function sortOrdersByCreatedAt(orders, type = 'asc') {

  let shortedList = orders.sort((a,b) => {
    let timeA = Moment(a.createdAt).toDate();
    let timeB = Moment(b.createdAt).toDate();
    return type === 'asc' ? (timeA.getTime() - timeB.getTime()) : (timeB.getTime() - timeA.getTime())
  })
  return shortedList;
}



// WEBPACK FOOTER //
// ./src/utils/ordersHelper.js